import { durationToString, secondsToMs } from '#utils';

const getXAxisOptions = () => ({
  offset: true,
  ticks: {
    maxTicksLimit: 20,
    maxRotation: 45,
    minRotation: 45,
    autoSkip: true,
    autoSkipPadding: 10,
  },
  grid: {
    display: false,
  },
});

const getYAxisOptions = (dataType) => ({
  type: 'linear',
  ticks: {
    maxTicksLimit: 10,
    ...(dataType === 'time' && {
      callback: (timeInSeconds) => durationToString(secondsToMs(timeInSeconds)),
    }),
  },
  grid: {
    color: 'rgba(128, 128, 128, 0.3)', // TODO: change this
  },
});

const getTooltipOptions = (dataType) => ({
  mode: 'index',
  backgroundColor: 'rgba(0, 0, 0, 0.9)',
  intersect: false,
  titleSpacing: 6,
  padding: 8,
  bodySpacing: 3,
  boxPadding: 3,
  ...(dataType === 'time' && {
    callbacks: {
      label: (item) => {
        const { label } = item.dataset;
        const { y: timeInSeconds } = item.parsed;
        return `${label}: ${durationToString(timeInSeconds * 1000)}`;
      },
    },
  }),
});

const getLegendOptions = () => ({
  position: 'bottom',
  labels: {
    usePointStyle: true,
    pointStyle: 'rect',
  },
});

export const getChartOptions = (dataType) => ({
  responsive: true,
  maintainAspectRatio: false,
  hover: {
    mode: 'index',
    intersect: false,
  },
  scales: {
    x: getXAxisOptions(),
    y: getYAxisOptions(dataType),
  },
  layout: {
    padding: {
      bottom: 32,
    },
  },
  plugins: {
    tooltip: getTooltipOptions(dataType),
    legend: getLegendOptions(),
  },
});
